window.TipoEntregaOrcamentoController = ControllerBase.extend({
    name: "TipoEntregaOrcamentoController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_TipoEntrega",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
            }
        };
    },

    atualizarBotoes: function() {
        this.renderActionButtons();
    },

    carregarPaginador: function(data) {

        this.paginador = new Paginator({
            container: "#page-tipo-entrega",
            data: data,
            pageClickCallback: $.proxy(self.paginar, self)
        });
    },

    paginar: function(e) {
        this.pesquisar(e.page);
    },

    pesquisar: function(pagina) {

        this.filtros = {
            TamanhoPagina: 20,
            NumeroPagina: pagina ? pagina : this.filtros && this.filtros.pagina ? this.filtros.pagina : 1,
            IdentificadorOrcamento: this.orcamento.get("IdentificadorOrcamento")
        };
               

        var self = this;

        global.ajax({
            url: "/Orcamento/ListarTiposEntregaOrcamento",
            type: "post",
            data: global.toJSONString({
                filtros: this.filtros
            }),
            success: function(data) {

                if (!data) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);
                self.model.TiposEntrega(m());
                self.carregarPaginador(data);
            }
        });

    },

    editar: function(model) {
        $("input").on('focus', function () { $(this).select(); });
        this.editarTipoEntregaOrcamentoController = this.showView({
            region: {
                name: "editarTipoEntregaOrcamentoRegion",
                selector: "#editar-tipo-entrega-region"
            },
            model: model,
            controller: {
                type: EditarTipoEntregaOrcamentoController,
                args: {
                    orcamento: this.orcamento,
                    finalizarCallback: $.proxy(this.finalizarEdicao, this),
                    readOnly: this.readOnly
                }
            }
        });
    },

    finalizarEdicao: function() {
        this.editarTipoEntregaOrcamentoController.hide();
        this.pesquisar();
        this.show();

    }

});